//
export default {
    /**
     * @description
     * adder dialog props
     */
    adderProps: {
        type: Object,
        default: () => ({}),
    },

    /**
     * 
     */
    alwaysExport: {
        type: Boolean,
    },

    /**
     * @description
     * attach params requests
     */
    attachParams: {
        type: Object,
        default: () => ({}),
    },

    /**
     * @description
     * determine if can card
     */
    card: Boolean,

    /**
     * @description
     * determine if can check (select) table items
     */
    checkable: Boolean,

    /**
     * @description
     * checkbox color
     */
    checkboxColor: {
        type: String,
        default: 'accent',
    },

    /*
     * @description
     * If true, checkbox selected items will be stored even if pages change
     * or filters are applied
     */
    persistentSelection: {
        type: Boolean,
        default: true,
    },

    /**
     * @description
     * determine the color of the table
     */
    color: {
        type: String,
        default: 'primary',
    },

    /**
     * @description
     * set the default limit to display items
     */
    defaultLimit: {
        type: [String, Number],
        default: 10,
    },

    /**
     * @description
     * determine if the table can be editable
     */
    editable: Boolean,

    /**
     * @description
     * the export xlsx file name
     */
    exportName: {
        type: String,
        default: 'export.data',
    },

    /**
     * @description
     * the export xlsx file title
     */
    exportTitle: {
        type: String,
        default: 'Export Data',
    },

    /**
     * @description
     * headers table definitions
     */
    headers: {
        type: Array,
        default: () => [],
    },

    /**
     * @description
     * set the white-space style attribute of headers
     */
    headersWhiteSpace: {
        type: String,
        default: 'nowrap',
    },

    /**
     * @description
     * filters definitions
     */
    filters: {
        type: Array,
        default: () => [],
    },

    /**
     * @description
     * values for the filter fields on table's first load
     */
    initialFilterValues: {
        type: Object,
        default: () => ({}),
    },

    /**
     * @description
     * loading color of progress bars and circles
     */
    loadingColor: {
        type: String,
        default: 'accent',
    },

    /**
     * @description
     * loading text of the table
     */
    loadingText: {
        type: String,
        default: 'Cargando datos...',
    },

    /**
     * @description
     * prepend map function to table data items
     */
    mapper: {
        type: [Boolean, Function],
        default: () => res => res,
    },

    /**
     * @description
     * prepend map function to table data filter
     */
    mapperFilter: {
        type: Function,
        default: filter => filter,
    },

    /**
     * @description
     * hide the actions column
     */
    noActions: Boolean,

    /**
     * @description
     * default text displayed in empty table
     */
    noDataText: String,

    /**
     * @description
     * hide the detail action
     */
    noDetail: Boolean,

    /**
     * @description
     * hide the export option
     */
    noExport: Boolean,

    /**
     * @description
     * hide the filter option
     */
    noFilter: Boolean,

    /**
     * @description
     * hide the helper option
     */
    noHelper: Boolean,

    /**
     * @description
     * hide the pagination (top & bottom)
     */
    noPagination: Boolean,

    /**
     * @description
     * hide the refresh action
     */
    noRefresh: Boolean,

    /**
     * @description
     * hide the remove action
     */
    noRemove: Boolean,

    /**
     * @description
     * hide the toolbar
     */
    noTools: Boolean,

    /**
     * @description
     * hide the search box input
     */
    noSearch: Boolean,

    /**
     * @description
     * static param filter
     */
    paramFilter: {
        type: Object,
        default: () => ({}),
    },

    /**
     * @description
     * filter name for search box input
     */
    paramSearch: {
        type: String,
        default: () => 'search',
    },

    /**
     *
     */
    parser: {
        type: Function,
        default: res => res,
    },

    /**
     * The persistent data atributtes of selected options
     */
    persistentData: {
        type: Array,
        default: () => [],
    },

    /**
     * @description
     * picker dialog props
     */
    pickerProps: {
        type: Object,
        default: () => ({}),
    },

    /**
     * @description
     * set the all table in read-only
     */
    readonly: Boolean,

    /**
     * @description
     * { item_description }
     */
    remindKey: String,

    /**
     * @description
     * default "rows per page" length to display in native pagination
     */
    rowsPerPage: {
        type: Number,
        default: 50,
    },

    /**
     * @description
     * default "rows per page" items to display in native pagination
     */
    rowsPerPageItems: {
        type: Array,
        default: () => [10, 15, 25, 50],
    },

    /**
     * @description
     * default "rows per page" text to display in native pagination
     */
    rowsPerPageText: {
        type: String,
        default: () => 'Items por pagina',
    },

    /**
     * @description
     * rules to validate only v-model
     */
    rules: {
        type: Array,
        default: () => [],
    },

    /**
     * toolbar search placeholder
     */
    searchPlaceholder: {
        type: String,
        default: 'Escriba un valor para buscar...',
    },

    /**
     * @description
     * show the selectable columns
     */
    selectableColumns: {
        type: Boolean,
        default: true,
    },

    /**
     * @description
     * set the selectable items to only one
     */
    selectedKey: {
        type: String,
        default: 'id',
    },

    /**
     * @description
     * set the selectable items to only one
     */
    selectedOne: Boolean,

    /**
     * @description
     * the service with the "fetchDataTable" function
     */
    service: [Function, Object],

    /**
     * @description
     * show the native pagination from vuetify
     */
    showNativePagination: Boolean,

    /**
     * @description
     * show adder dialog option
     */
    showAdder: Boolean,

    /**
     * @description
     * show picker dialog options
     */
    showPicker: Boolean,

    /**
     * @description
     * show remove option
     */
    showRemove: Boolean,

    /**
     * @description
     * set the table title
     */
    title: String,

    /**
     * @description
     * set the default toolbar color
     */
    toolbarColor: {
        type: String,
        default: 'white',
    },

    /**
     * @description
     * set the default toolbar theme (dark or light)
     */
    toolbarDark: Boolean,

    /**
     * @description
     * set the default toolbar height
     */
    toolbarDense: Boolean,

    /**
     * @description
     * set the default toolbar title
     */
    toolbarTitle: String,

    /**
     * @description
     * set the default items to show when not has service
     */
    value: {
        type: Array,
        default: () => [],
    },
}
